export default __webpack_public_path__ + "static/media/rightArrows.409ae308.svg";